export const requiredDropDownFields = [
  {
    name: 'forestSourcingArea',
    typeOfInp: 'select',
    label: 'Forest Sourcing Area (County)',
    width: 4,
  },
  {
    name: 'supplierType',
    typeOfInp: 'select',
    label: 'Supplier Type',
    width: 4,
  },
  {
    name: 'validSelfDeclaration',
    typeOfInp: 'select',
    label: 'Valid Self Declaration',
    width: 4,
  },
  {
    name: 'biomassSite',
    typeOfInp: 'select',
    label: 'Biomass Site',
    width: 4,
  },
  {
    name: 'forestGrower',
    typeOfInp: 'input',
    label: 'Forest Grower',
    textFieldType: 'text',
    isTextArea: false,
    width: 4,
  },
  {
    name: 'contractWith',
    typeOfInp: 'select',
    label: 'Contract with',
    width: 4,
  },
  {
    name: 'harvestedBy',
    typeOfInp: 'select',
    label: 'Harvested By',
    width: 4,
  },
  {
    name: 'tripartiteAgreement',
    typeOfInp: 'select',
    label: 'Tripartite Agreement',
    width: 4,
  },
  {
    name: 'notes',
    typeOfInp: 'input',
    label: 'Notes',
    textFieldType: 'text',
    isTextArea: false,
    width: 12,
  },
];

export const requiredCertificationInformationDropDownOption = {
  forestSourcingArea: [
    'Antrim',
    'Armagh',
    'Carlow',
    'Cavan',
    'Clare',
    'Cork',
    'Derry',
    'Donegal',
    'Down',
    'Dublin',
    'Fermanagh',
    'Galway',
    'Kerry',
    'Kildare',
    'Kilkenny',
    'Laois',
    'Leitrim',
    'Limerick',
    'Longford',
    'Louth',
    'Mayo',
    'Meath',
    'Monaghan',
    'Offaly',
    'Roscommon',
    'Sligo',
    'Tipperary',
    'Tyrone',
    'Waterford',
    'Westmeath',
    'Wexford',
    'Wicklow',
  ],
  supplierType: ['Sawmill', 'Forest', 'Hedgerow', 'Site Clearance', 'Storage', 'N/A'],
  validSelfDeclaration: ['Yes', 'No'],
  biomassSite: ['Yes', 'No'],
  contractWith: ['ECC', 'Murrays', 'Coillte', 'SWS', 'IFUT', 'Private', 'Other - add in notes>'],
  harvestedBy: ['WTG', 'ECC', 'Murrays', 'Other'],
  tripartiteAgreement: ['Yes', 'No'],
};
